import { render, staticRenderFns } from "./GameTransactionMember.vue?vue&type=template&id=66de78fe&"
import script from "./GameTransactionMember.vue?vue&type=script&lang=ts&"
export * from "./GameTransactionMember.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports